document.addEventListener('click', function (e) {
	var button = e.target.closest('[data-product-card-carousel-prev], [data-product-card-carousel-next]');
	if (!button) return;

	var carousel = button.closest('[data-product-card-carousel]');
	if (!carousel) return;

	var track = carousel.querySelector('[data-product-card-carousel-track]');
	if (!track) return;

	e.preventDefault();
	e.stopPropagation();

	var direction = button.hasAttribute('data-product-card-carousel-next') ? 1 : -1;
	track.scrollBy({ left: track.clientWidth * direction, behavior: 'smooth' });
});

// Segmented progress line: one segment per image, the segment matching the
// currently visible slide is filled, the rest stay transparent. Kept in sync
// with every way the track can move (swipe, arrows, wheel).
document.addEventListener('click', function (e) {
	var segment = e.target.closest('[data-product-card-carousel-progress-segment]');
	if (!segment) return;

	var progress = segment.closest('[data-product-card-carousel-progress]');
	var carousel = segment.closest('[data-product-card-carousel]');
	if (!progress || !carousel) return;

	var track = carousel.querySelector('[data-product-card-carousel-track]');
	if (!track) return;

	var index = Array.prototype.indexOf.call(progress.children, segment);
	if (index < 0) return;

	e.preventDefault();
	e.stopPropagation();

	track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
});

function updateCarouselProgress(track) {
	var carousel = track.closest('[data-product-card-carousel]');
	var progress = carousel && carousel.querySelector('[data-product-card-carousel-progress]');
	if (!progress) return;

	var width = track.clientWidth;
	if (!width) return;

	var index = Math.round(track.scrollLeft / width);
	var segments = progress.children;

	for (var i = 0; i < segments.length; i++) {
		segments[i].classList.toggle('is-active', i === index);
	}
}

document.addEventListener(
	'scroll',
	function (e) {
		var track = e.target.closest && e.target.closest('[data-product-card-carousel-track]');
		if (!track) return;

		updateCarouselProgress(track);
	},
	true
);

var wheelLocks = new WeakMap();
var WHEEL_NAV_MAX_CONTAINER_WIDTH = 0;

document.addEventListener('wheel', function (e) {
	var track = e.target.closest('[data-product-card-carousel-track]');
	if (!track) return;

	var container = track.closest('.products') || track.closest('[data-product-card-carousel]');
	if (!container || container.clientWidth >= WHEEL_NAV_MAX_CONTAINER_WIDTH) return;
	if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;

	e.preventDefault();
	if (wheelLocks.get(track)) return;

	var direction = e.deltaY > 0 ? 1 : -1;
	track.scrollBy({ left: track.clientWidth * direction, behavior: 'smooth' });

	wheelLocks.set(track, true);
	setTimeout(function () { wheelLocks.set(track, false); }, 500);
}, { passive: false });
